<section mat-dialog-title>
  <span class="test-title">New Firmware available</span>
  <button mat-dialog-close>
    <mat-icon fontIcon="close" />
  </button>
</section>
<mat-dialog-content>
  <p class="text-sm text-ui-dark mb-2">
    <span class="font-bold">{{ data.firmware.version }}</span>
    version of a Firmware was released on {{ data.firmware.createdAt | date : 'MMM d, yyyy HH:mm'  }}.
    <br />
    Do you wish to update current Firmware ({{ data.currentVersion }})?.
  </p>
  <avs-message type="warning">
    Your device will restart to apply the update.
  </avs-message>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button
    class="test-btn-cancel btn-transparent btn-medium font-bold mr-4"
    mat-dialog-close
  >Cancel
  </button>
  <button
    type="submit"
    class="btn-green btn-medium font-bold"
    (click)="confirm()"
    [disabled]="isFirmwareUpdating()"
  >
    Update
  </button>
</mat-dialog-actions>
